exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".regions-page {\n  width: 100%;\n  flex-grow: 1;\n  display: flex;\n}\n.regions-page__content {\n  display: flex;\n  padding: 32px;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Regions/containers/regions.less
// module id = 1097
// module chunks = 0